import { FormFileInputComponent } from 'src/features/generalForms/builder/types/FileInput';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { AppAttachmentValue } from 'uikit/fields/attachments/attachmentsField/appAttachmentsField';
import { RPDF } from 'src/features/report/react-pdf';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';

export const FormFileInput: FormFileInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <RPDF.View />;
  }

  return (
    <AnswerPreviewRow<AppAttachmentValue[]>
      {...props}
      value={value}
      renderValue={(val) => val.map((v) => v.fileName).join('\n')}
    />
  );
};
